import Axios from "axios";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import { showLoading } from "react-global-loading";

const cookies = new Cookies();

// Support both build-time and runtime environment variables
const baseUrl = window.env?.API_URL || process.env.REACT_APP_API_URL || "http://localhost:3001";
const tokenName = window.env?.API_TOKEN_NAME || process.env.REACT_APP_API_TOKEN_NAME || "udatxu";
const loginPath = "/auth/sign-in/";
const dashboardPath = "/dashboard/";

let contentType = "application/json";

let api = Axios.create({
    baseURL: baseUrl,
    timeout: 30000, // 30 seconds for Argon2 hashing + email sending
});

function post(url, data, config="") {
    contentType = config.length === 0 ? contentType : config;
    return api.post(url, data);
}

function get(url, data={}, config="") {
    contentType = config.length === 0 ? contentType : config;
    return api.get(url);
}

function checkToken() {
    const _token = cookies.get(tokenName);
    if (_token) {
        return true;
    }
    return false;
}
function getToken() {return cookies.get(tokenName);}
function setToken(tokenValue) {
    cookies.set(tokenName, tokenValue, { path: "/" });
}
function removeToken() {cookies.remove(tokenName, { path: "/" });}

function checkUser() {return localStorage.getItem("user");}
function setUser(user) {localStorage.setItem("user", JSON.stringify(user));}
function removeUser() {localStorage.removeItem("user");}
function getUser() {
    const blankData = { name: "", email: "", role: "" };
    if (checkUser() === null) return blankData;
    return checkUser() && JSON.parse(localStorage.getItem("user"));
}

function checkUserActive() {
    const _token = cookies.get(tokenName);
    const _user = getUser();
    // User is considered active only if:
    // 1. Token exists
    // 2. User data exists
    // 3. User status is "active"
    if (_token && _user && _user.user_status === "active") {
        return true;
    }
    return false;
}


api.interceptors.request.use((config) => {
    const _token = getToken();

    if (_token) {
        config.headers.Authorization = `Bearer ${_token}`;
    }
    config.headers["Content-Type"] = contentType;
    
    // Show loading indicator (except for /deadline endpoint)
    if (config.url !== '/deadline') {
        showLoading(true);
    }
    
    return config;
}, (error) => {
    return Promise.reject(error);
});

api.interceptors.response.use(
    (response) => {
        // Hide loading spinner
        showLoading(false);
        
        // Show success toast if response has success status
        // Ignore /deadline endpoint to avoid spamming notifications
        if (response.config.url !== '/deadline' &&
            response.data &&
            response.data.status === 'success' &&
            response.data.message) {
            toast.success(response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        return response;
    },
    (error) => {
        // Hide loading spinner
        showLoading(false);
        
        // Show error toast for API errors
        // Ignore /deadline endpoint errors
        if (error.config?.url !== '/deadline') {
            if (error.response) {
                // Server responded with error status
                const errorMessage = error.response.data?.message || error.response.data?.error || 'An error occurred';
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } else if (error.request) {
                // Request made but no response
                toast.error('No response from server. Please check your connection.', {
                    position: "top-right",
                    autoClose: 5000,
                });
            } else {
                // Other errors
                if (error.message !== "Error Processing Token") {
                    toast.error(error.message, {
                        position: "top-right",
                        autoClose: 5000,
                    });
                }
            }
        }

        // Handle token errors
        if (error.message === "Error Processing Token") {
            removeToken();
            removeUser();
            window.location.href = loginPath;
        }
        return Promise.reject(error);
    }
);

export {
    get,
    post,
    baseUrl,
    loginPath,
    dashboardPath,
    tokenName,
    checkToken,
    checkUserActive,
    getToken,
    setToken,
    removeToken,
    checkUser,
    setUser,
    removeUser,
    getUser
};

export default api;